import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { CommonResponse } from 'models';
import { AssetUse } from './models/assetUse';

export interface AssetUseState {
  loading: boolean;
  list: AssetUse[];
}

const initialState: AssetUseState = {
  loading: false,
  list: [],
};

const assetUseSlice = createSlice({
  name: 'asset_use',
  initialState,
  reducers: {
    fetchAssetUseList(state) {
      state.loading = true;
    },
    fetchAssetUseSuccess(state, action: PayloadAction<CommonResponse<AssetUse[]>>) {
      state.list = action.payload.data;
      state.loading = false;
    },
    fetchAssetUseFailed(state) {
      state.loading = false;
    },
  },
});

// Actions
export const assetUseActions = assetUseSlice.actions;

// Selectors
export const selectAssetUseLoading = (state: RootState) => state.assetUse.loading;
export const selectAssetUseList = (state: RootState) => state.assetUse.list;

// Reducer
export const assetUseReducer = assetUseSlice.reducer;
